import { useMutationObserver } from '../useMutationObserver/useMutationObserver';
export const useCompStyleElementObserver = ({ compIds, ...props }) => useMutationObserver({
    ...props,
    options: { subtree: true, characterData: true },
    elements: compIds.map(compId => document.querySelector(`style[data-comp-id=${compId}`)),
});
//# sourceMappingURL=useCompStyleElementObserver.js.map